<template>
  <div
    class="product-usp-slider container"
    :class="{
      'is-edit-mode': isMagnoliaEdit,
    }"
  >
    <EditableArea :content="main">
      <SliderElement
        :components="mapNodes(main)"
        :swiper-options="swiperOptions"
        :reveal-animation="false"
      ></SliderElement>
    </EditableArea>
  </div>
</template>

<script setup>
import { mapNodes } from "~/utils/helper/magnolia";
import { EditableArea } from "@magnolia/vue-editor";
import { screens } from "~/tailwind.config.screens";
import SliderElement from "~/templates/elements/SliderElement.vue";

const { isMagnoliaEdit } = useMagnoliaContext();

const props = defineProps(["main", "loop"]);

const swiperOptions = {
  a11y: true,
  autoHeight: true,
  spaceBetween: 32,
  centeredSlides: true,
  slidesPerView: "auto",
  loop: props.loop ?? false,
  breakpoints: {
    [parseInt(screens.md)]: {
      initialSlide: Math.floor(mapNodes(props.main).length / 2),
      autoHeight: false,
      spaceBetween: 64,
    },
  },
};
</script>

<style>
.product-usp-slider {
  .swiper,
  .swiper-wrapper {
    @apply mx-auto overflow-visible;
  }
  &.is-edit-mode .swiper-wrapper {
    @apply !h-auto !overflow-auto;
    transform: none !important;
  }
  .swiper-slide-active {
    picture {
      @apply scale-110;
    }
  }
  .swiper-slide {
    @apply w-10/12 md:w-4/12 xl:w-3/12;

    picture {
      @apply transform duration-300;
    }
  }
  .usp-slide-picture-height {
    @apply aspect-2/3 h-full max-h-128;
  }
}
</style>
